import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import './PortofolioItemComponent.css';
import portofolioImage from "../../../../assets/images/project//rumah/HNS_PIK2_HOUSE/00_pik2_cover.jpg";

function Portofolio03() {

    const navigate = useNavigate();
    const navigateHome = () => {
        navigate('/detail-project/portofolio-fawn-house');
    };

    return (
        <div className='portofolio-rumah-01' id='id-portofolio-01'>
            <div className="portofolio-rumah-01-container">
                <div className='portofolio-rumah-01-container-img'>
                    <img src={portofolioImage} alt="imgFoto" className="portofolio-rumah-01-image" />
                </div>

                <div className="portofolio-rumah-01-overlay" onClick={navigateHome}>
                    <h1>Hns House</h1>
                    <p>Pantai Indah Kapuk - PIK2, Jakarta Utara</p>
                </div>
            </div>
        </div>
    );
}

export default Portofolio03;